// Update contents object below

const contents = {
  header: 'Destination Canada',
  logoTooltip: {
    href: 'https://us-keepexploring.canada.travel/',
    copy: 'https://us-keepexploring.canada.travel/',
    logoPlacement: 'above'
  },
  video:
    'https://player.vimeo.com/video/781626782?h=5d9c409026&color=b89544&title=0&byline=0&portrait=0',
  videoTitle: 'Destination Canada - Ep. 2 Ontario',
  videoAutoPlay: true,
  title: 'episode 2: Ontario',
  copy:
    'This expedition filmmaker and cultural heritage advocate paddles his way through Ontario’s gorgeous parks and natural waterways to explore the significance of the canoe – and discover the uniquely Canadian heritage and spirit which connects the past to the present.',
  url: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
  button: 'return to hub',
  url2:
    'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/british-columbia/'
};

export default contents;
